$(function() {
    $('#content').on('click', '.accordion-trigger', function (e) {
        var $list = $(this).closest('.accordion-list');

        if ($list.length) {
            e.preventDefault();
            var $items = $('> .accordion-item.active', $list),
                $target = $(this).closest('.accordion-item');

            if ($target.hasClass('active')) {
                return;
            }

            $('.accordion-triggerable', $items)
                .stop(true, true)
                .slideUp();

            $items.removeClass('active');
            $target.addClass('active');

            $('.accordion-triggerable', $target)
                .stop(true, true)
                .slideDown();
        }
    });
});